import cloneDeep from 'lodash.clonedeep';
import set from 'lodash.set';
import get from 'lodash.get';

import types from './constants';
import { states } from '../../values/enums';
import Sorting from '../../util/sorting';
import reportReducers from '../reducers';

const dirs = Sorting.DIRS;
const benchmarkSorting = new Sorting({
  first_name: dirs.asc,
  score: dirs.asc,
});

const defaultReducer = (state, action) => (state)

const dyslexiaSort = (state, action) => {
  let next = cloneDeep(state)
  let nextSorts;
  nextSorts = benchmarkSorting.run(
    get(next, 'report.data.scores'),
    action.sort,
    get(next, 'sorts', [])
  )
  set(next, 'report.data.scores', nextSorts.data)
  set(next, 'sorts', nextSorts.sorts)
  return next
}

const reportCacheSave = (state, action) => {
  let next = cloneDeep(state)
  const { activities, students } = action.payload
  const cache = cloneDeep(next.report.cachedData) || {}
  const classroomCache = cache[action.payload.classroomId] || {}
  next.report.cachedData = {
    ...next.report.cachedData,
    [action.payload.classroomId]: {
      ...classroomCache,
      activities: activities || classroomCache.activities,
      students: students || classroomCache.students,
    }
  }
  return next
}

const reportPending = (state, action) => {
  let next = cloneDeep(state);
  set(next, 'report.status', {type: states.PENDING});
  set(next, 'report.data', null)
  set(next, 'report.score', null)
  return next;
}

const reportComplete = (state, action) => {
  let next = cloneDeep(state);
  if(action.report){
    set(next, 'report.data', action.report);
    set(next, 'report.status', {type: states.COMPLETE});
  }
  if(action.report && action.report.scores) {
    let nextSorts;
    nextSorts = benchmarkSorting.run(
      action.report.scores,
      action.sort || 'score',
      get(next, 'sorts', [{type: "score", dir: "desc"}]),
      false
    );
    set(next, 'report.data.scores', nextSorts.data);
    set(next, 'sorts', nextSorts.sorts);
  }
  return next
}

const reportError = (state, action) => {
  let next = cloneDeep(state);
  set(next, 'report.status', {type: states.ERROR, data: action.error});
  return next;
}

const actionReducer = Object.assign({
  [types.DYSLEXIA_SORT]: dyslexiaSort,
  [types.DYSLEXIA_PENDING]: reportPending,
  [types.DYSLEXIA_COMPLETE]: reportComplete,
  [types.DYSLEXIA_ERROR]: reportError,
  [types.DYSLEXIA_CACHE_SAVE]: reportCacheSave,
}, reportReducers);

export default (state = {}, action = {type: null}) => {
  const reducer = actionReducer[action.type] || defaultReducer;
  return reducer(state, action);
}
